













import { computed, defineComponent, ref } from '@nuxtjs/composition-api'
import useProductPage from '~/composables/useProductPage'
import ChoosableModule from '~/components/ChoosableModule.vue';
import { SKU_SEPARATOR } from '~/utils/constants/code';
import scssVariables from 'static/resources/scssVariables.json';
import { ModuleVerticalOption } from '~/utils/types/Plan';
import { PREMIUM_MODULES_SKUS } from '~/utils/mocks/landings';
import { merge } from 'lodash-es';
export default defineComponent({
    components:{
        ChoosableModule
    },
    data(){
    return{
      choosenModules: new Map()
    }
  },
    setup() {
        const { product, toggleModule, modulesKeys, getChoosenModules, paymentFrequencyChoosen, addToCartConfigs, setAddToCartConfigs } = useProductPage();
        const premiumModules = ref<ModuleVerticalOption[]>([])
        const professionalModules = ref<ModuleVerticalOption[]>([])
        product.value.modules.forEach(module => {
            PREMIUM_MODULES_SKUS.includes(module.product.sku) ? premiumModules.value.push(module) : professionalModules.value.push(module) 
        })
        return {
            product, 
            professionalModules,
            premiumModules,
            toggleModule,
            modulesKeys,
            getChoosenModules,
            paymentFrequencyChoosen,
            addToCartConfigs,
            setAddToCartConfigs,
            modulesSkus : computed(()=>modulesKeys.value.sort().map(k => k.split(SKU_SEPARATOR)[1])),
            color: scssVariables.colors['product-accent']
            
        }
    },
    methods:{
    toggleSelectModule(product){
        let newCartConfig = Object.assign({}, this.addToCartConfigs);
        if(product.attribute_set_id === 21){ //Se è un modulo filegrant il prezzo deve cambiare in modo dinamico
            if(product.sku == newCartConfig?.['moduleSku']){
                delete newCartConfig['moduleSku'];
                delete newCartConfig['moduleCost'];
            }else{
                newCartConfig['moduleSku'] = product.sku;
                newCartConfig['moduleCost'] = product.price_range.maximum_price.final_price.value;
            }
        }else{
            if(!!newCartConfig['moduleSku']){
                delete newCartConfig['moduleSku'];
                delete newCartConfig['moduleCost'];
            }
        }
        this.setAddToCartConfigs(merge({}, newCartConfig)); 
        this.toggleModule(product)
        this.choosenModules = this.getChoosenModules(); // refresh view
    }
  }
})
